import Chevron from '../chevron';
import { useTranslation } from 'react-i18next';
import React, { useRef, useState } from 'react';

import './accordion.scss';

const TRANSITION_DURATION_MS = 600;

interface IArgs {
    title: string;
    content: any;
    icon?: string;
    isError?: boolean;
}

const Accordion = ({ title, content, icon, isError }: IArgs) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [setHeight, setHeightState] = useState<string>('0px');
    const [setRotate, setRotateState] = useState<string>('accordion__icon');
    const element: any = useRef(null);
    let errorClass = '';
    let errorContentClass = '';
    let chevronColor = '#777';
    if (isError) {
        errorClass = 'accordion__error';
        errorContentClass = 'accordion__error error__content';
        chevronColor = '#fff';
    }
    function toggleAccordion() {
        const opening = !isOpen;
        setIsOpen(opening);
        setHeightState(opening ? `${element.current?.scrollHeight}px` : '0px');
        setRotateState(opening ? 'accordion__icon rotate' : 'accordion__icon');
        // After transition, switch to 'none' so nested accordions can grow
        if (opening) {
            setTimeout(() => {
                setHeightState('none');
            }, TRANSITION_DURATION_MS);
        }
    }
    return (
        <div className={`accordion__section__document ${errorClass}`}>
            <div
                className={`accordion ${isOpen ? 'active' : ''} ${errorClass}`}
                onClick={toggleAccordion}
            >
                <a className={`accordion__title ${errorClass}`}>
                    {icon && (
                        <i
                            className={`c-icon-list__icon c-icon c-icon--[${icon}]`}
                            aria-hidden='true'
                            role='img'
                        />
                    )}
                    {t(title)}
                </a>
                <span>
                    <Chevron
                        className={`${setRotate}`}
                        width={50}
                        fill={chevronColor}
                    />
                </span>
            </div>
            <div
                ref={element}
                style={{ maxHeight: `${setHeight}` }}
                className={`accordion__content ${errorContentClass}`}
            >
                <div className='accordion__text'>{content}</div>
            </div>
        </div>
    );
};

export default Accordion;
